var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 12.5L4.29289 13.2071L3.58579 12.5L4.29289 11.7929L5 12.5ZM26 22.5C26 23.0523 25.5523 23.5 25 23.5C24.4477 23.5 24 23.0523 24 22.5L26 22.5ZM10.5429 19.4571L4.29289 13.2071L5.70711 11.7929L11.9571 18.0429L10.5429 19.4571ZM4.29289 11.7929L10.5429 5.54289L11.9571 6.95711L5.70711 13.2071L4.29289 11.7929ZM5 11.5L19 11.5L19 13.5L5 13.5L5 11.5ZM26 18.5L26 22.5L24 22.5L24 18.5L26 18.5ZM19 11.5C22.866 11.5 26 14.634 26 18.5L24 18.5C24 15.7386 21.7614 13.5 19 13.5L19 11.5Z",
    fill: "#33363F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/Back.b2cc4976424a83d3dc5d6e1350c077bd.svg";
export { ForwardRef as ReactComponent };